var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectsSprite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      position: "absolute",
      width: 0,
      height: 0
    },
    width: 0,
    height: 0,
    xmlns: "http://www.w3.org/2000/svg",
    xlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "close",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-739 -263)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(739 263)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13234.071,9294.485l-5.655,5.656-1.416-1.412,5.657-5.658-5.657-5.657,1.416-1.412,5.654,5.655,5.657-5.659,1.416,1.416-5.658,5.657,5.658,5.658-1.416,1.412Z",
    transform: "translate(-12483 -9017.998)"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "approve",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-709 -263)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(709 263)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13227,9289.535l1.413-1.413,7.778,7.778-1.413-1.416,8.483-8.483,1.416,1.413-8.486,8.486-1.413,1.412Z",
    transform: "translate(-12516 -9017)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectsSprite);
export default __webpack_public_path__ + "static/media/projects_sprite.4447631d7b1188f67f8fba3550f841b4.svg";
export { ForwardRef as ReactComponent };